import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AGENT_ALLIANCE_CHAT_MESSAGES_QUERY_KEY } from './useFetchAllianceChatMessages';
import { AGENT_ALLIANCE_APPLICATION_DETAIL_QUERY_KEY } from './useFetchAgentAllianceApplicationDetail';
import { AGENT_ALLIANCE_APPLICATIONS_QUERY_KEY } from './useFetchAllianceApplications';

export default function useReadAllianceChatMessages() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (applicationId: string) => {
      const response = await fetch(
        `/agent/api/alliance_applications/${applicationId}/chat_messages/read`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
        }
      );
      if (!response.ok) throw new Error('既読処理に失敗しました');
      return response.json();
    },
    onSuccess: (_, applicationId) => {
      void queryClient.invalidateQueries({
        queryKey: [...AGENT_ALLIANCE_CHAT_MESSAGES_QUERY_KEY, applicationId],
      });
      void queryClient.invalidateQueries({
        queryKey: AGENT_ALLIANCE_APPLICATION_DETAIL_QUERY_KEY,
      });
      void queryClient.invalidateQueries({
        queryKey: AGENT_ALLIANCE_APPLICATIONS_QUERY_KEY,
      });
    },
  });
}
